import React from 'react';
// import Footer from './Footer';
import { useNavigate } from "react-router-dom";

const IoTIntegrationPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
        .page-hero-title {
          opacity: 0;
          transform: translateY(28px) scale(0.98);
          animation: pageHeroTitleReveal 1s ease-out forwards;
        }

        @keyframes pageHeroTitleReveal {
          0% {
            opacity: 0;
            transform: translateY(28px) scale(0.98);
            letter-spacing: 0.02em;
            filter: blur(8px);
          }
          60% {
            opacity: 1;
            transform: translateY(-4px) scale(1.01);
            filter: blur(0);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
            letter-spacing: 0;
            filter: blur(0);
          }
        }
      `}</style>
      <div style={{ backgroundColor: '#fff', color: '#000' }}>
        <section className="section" style={{ maxWidth: 1200, margin: '0 auto', padding: '120px 20px' }}>
          
            {/* Back Button */}
      <div style={{ marginBottom: 30 }}>
       <p
       style={{
      display: "inline-block",
      cursor: "pointer",
      margin: 0,
      fontSize: 14,
      color: "#555555"
       }}
      onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
      onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
      onClick={() => navigate("/", { state: { openMenu: true } })}
  >
      ← Back to Menu
      </p>
      </div>

          <h1 className="page-hero-title" style={{ marginBottom: 24, textAlign: 'left' }}>AI-Driven Skyscraper Intelligence</h1>
          <p style={{ opacity: 0.85, lineHeight: 1.7, maxWidth: 900 }}>
            We transform skyscrapers into smart, sustainable, and self-optimizing ecosystems. From design to
            daily operations, AI enhances safety, efficiency, and environmental performance.
          </p>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Our AI-Enhanced Skyscraper Services</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginTop: 12 }}>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Smart Architectural Design</h3>
                <p>Simulate wind, solar, and urban density to optimize form and function.</p>
                <p style={{ opacity: 0.8 }}>Example: Generali Tower shaped via parametric design.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Autonomous Construction Monitoring</h3>
                <p>AI-powered drones and vision ensure safety and progress compliance.</p>
                <p style={{ opacity: 0.8 }}>Example: Hudson Yards used AI for real-time progress.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Intelligent Energy Management</h3>
                <p>AI controls HVAC, lighting, and water based on occupancy and weather.</p>
                <p style={{ opacity: 0.8 }}>Example: Salesforce Tower cut energy by 20%.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Predictive Maintenance & Asset Intelligence</h3>
                <p>Monitor elevators and mechanical assets to predict failures early.</p>
                <p style={{ opacity: 0.8 }}>Example: Shanghai Tower improved elevator uptime.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Smart Security & Access Control</h3>
                <p>Facial recognition and anomaly detection for secure, real-time response.</p>
                <p style={{ opacity: 0.8 }}>Example: Marina Bay Sands enhanced guest safety.</p>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Why Partner With Us</h2>
            <ul style={{ listStyle: 'disc', paddingLeft: 20, lineHeight: 1.8 }}>
              <li>AI-first approach to skyscraper innovation</li>
              <li>Custom integrations with legacy and smart systems</li>
              <li>Sustainability-focused energy optimization</li>
              <li>Real-time operational intelligence</li>
              <li>Scalable for new builds and retrofits</li>
            </ul>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default IoTIntegrationPage;


